module.exports = __webpack_public_path__ + "static/media/deviceMarker.a387cbee.svg";